import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=5c702d90&scoped=true&"
import script from "./DashCard.vue?vue&type=script&lang=js&"
export * from "./DashCard.vue?vue&type=script&lang=js&"
import style0 from "./DashCard.vue?vue&type=style&index=0&id=5c702d90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c702d90",
  null
  
)

export default component.exports